import StartBlock, { StartBlockProps } from './StartBlock';
import withInteractor from './StarBlock.interactor';
import withPresenter from './StartBlock.presenter';

export type { StartBlockProps };
export default withInteractor(withPresenter(StartBlock));
